import { ChangeDetectionStrategy, Component, computed, input, model } from '@angular/core';
import { NgClass, NgStyle } from '@angular/common';
import { IconsEnum, IconSize, OptionChipMode } from '@/shared/enums';
import { Icon } from '../icon/icon';

@Component({
  selector: 'bevvi-option-chip',
  imports: [NgClass, NgStyle, Icon],
  templateUrl: './option-chip.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OptionChip {
  public readonly label = input.required<string>();
  public readonly selected = model(false);
  public readonly mode = input<OptionChipMode>(OptionChipMode.MULTIPLE);
  public readonly disabled = input(false);
  public readonly textColor = input('var(--bot-primary, #100F0D)');
  public readonly selectedTextColor = input('var(--bot-secondary, #004251)');
  public readonly strokeColor = input('#E2E0D8');
  public readonly selectedFillColor = input('var(--bot-secondary, #004251)');

  protected readonly optionChipMode = OptionChipMode;
  protected readonly iconsEnum = IconsEnum;
  protected readonly iconSize = IconSize;

  protected readonly chipStyles = computed(() => ({
    '--chip-text': this.selected() ? this.selectedTextColor() : this.textColor(),
    '--chip-bg': this.selected()
      ? `color-mix(in srgb, ${this.selectedFillColor()} 20%, transparent)`
      : 'transparent',
    '--chip-stroke': this.selected() ? this.selectedFillColor() : this.strokeColor(),
  }));

  protected readonly chipClasses = computed(() => ({
    'opacity-50 cursor-not-allowed': this.disabled(),
    'cursor-pointer': !this.disabled(),
  }));

  public toggleSelection(): void {
    if (this.disabled()) return;
    const updatedValue = !this.selected();
    this.selected.set(updatedValue);
  }
}
